import useAspidaSWR from '@aspida/swr'
import React from 'react'
import { toast } from 'react-hot-toast'

import { useApiClient } from '@/hooks/useApiClient'

export const useGetNotifications = () => {
  const { apiClient, isReady } = useApiClient()

  const notifications = useAspidaSWR(apiClient.user_notifications, {
    enabled: isReady,
  })

  React.useEffect(() => {
    if (notifications.error) {
      toast.error('サーバーとの通信に失敗しました')
    }
  }, [notifications.error])

  return {
    ...notifications,
    data: notifications.data,
  }
}
